import React from "react";

const TriangleIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="69"
    height="61"
    viewBox="0 0 69 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.1222 2.5C32.0467 -0.833331 36.8579 -0.833336 38.7824 2.5L68.2273 53.5C70.1518 56.8333 67.7462 61 63.8972 61H5.00746C1.15846 61 -1.24717 56.8333 0.677332 53.5L30.1222 2.5Z"
      fill="url(#paint0_linear_1_35)"
    />
    <path
      d="M42.4206 29.4188C41.7656 29.4188 41.2346 29.9499 41.2346 30.6048C41.2346 31.2598 41.7656 31.7909 42.4206 31.7909C43.0755 31.7909 43.6066 31.2598 43.6066 30.6048C43.6066 29.9499 43.0755 29.4188 42.4206 29.4188Z"
      fill="white"
    />
    <path
      d="M46.0959 34.616C45.1373 34.616 44.3619 35.3931 44.3619 36.35C44.3619 37.3087 45.139 38.0841 46.0959 38.0841C47.0529 38.0841 47.83 37.307 47.83 36.35C47.83 35.3931 47.0529 34.616 46.0959 34.616Z"
      fill="white"
    />
    <path
      d="M38.3518 32.5374C37.1539 32.5374 36.1816 33.5096 36.1816 34.7075C36.1816 35.9054 37.1539 36.8776 38.3518 36.8776C39.5497 36.8776 40.5219 35.9071 40.5219 34.7075C40.5219 33.5096 39.5514 32.5374 38.3518 32.5374Z"
      fill="white"
    />
    <path
      d="M41.338 48.6665C39.7125 45.2765 34.5035 35.0519 33.214 32.5832C35.9271 29.9413 38.496 26.933 40.2555 24.7663C40.3352 24.7901 40.4184 24.8019 40.5049 24.8019C41.002 24.8019 41.4059 24.3981 41.4059 23.901C41.4059 23.4038 41.002 23 40.5049 23C40.0078 23 39.6039 23.4038 39.6039 23.901C39.6039 24.0282 39.6311 24.1487 39.6769 24.2573C37.8342 26.407 35.3146 29.1269 32.7712 31.6008C30.9828 28.2463 29.7086 26.3256 28.2545 25.4162C27.3365 24.8427 25.8502 24.8936 24.5437 25.954C21.4387 28.472 19.932 33.009 21.1553 36.467C21.61 37.7497 22.6111 38.2859 23.7072 38.4335C26.0691 38.7559 28.7771 37.2763 32.0535 34.1628C33.4278 36.8148 37.6425 44.9541 39.6989 49.3147C39.3172 49.7066 39.0813 50.2394 39.0813 50.8299C39.0813 52.0278 40.0536 53 41.2515 53C42.4494 53 43.4216 52.0295 43.4216 50.8299C43.4216 49.6625 42.4952 48.7123 41.338 48.6665ZM26.4746 36.3177C25.672 36.635 23.5511 37.1661 22.8775 34.7737C22.6043 33.8014 22.6077 30.8491 24.0058 28.8588C24.9085 27.5744 26.3219 26.122 27.9304 27.515C29.1198 28.5449 29.8307 30.1025 31.2916 32.8648C29.1317 34.9179 28.0542 35.6933 26.4746 36.3177Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_35"
        x1="0"
        y1="0"
        x2="79.6824"
        y2="39.2247"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CA378F" />
        <stop offset="1" stopColor="#123AC5" />
      </linearGradient>
    </defs>
  </svg>
);

export default TriangleIcon;
